<template>
    <div class="WorkOrderCreateModal">
        <h1>Add Work Order</h1>

        <p class="errorMessage" v-if="submitError">{{ submitError }}</p>

        <div class="main">
            <WorkOrderForm
                ref="workOrderForm"
                v-bind.sync="workOrder"
            />
        </div>

        <div class="actions">
            <Button class="link" @click="handleCancel">Cancel</Button>
            <Button class="primary" @click="handleCreate" :disabled="submitPending">Save</Button>
        </div>
    </div>
</template>

<script>
import WorkOrderForm from '@/views/company/workOrder/components/WorkOrderForm';
import workOrderCreateMixin from '@/mixins/workOrderCreateMixin';

export default {
    name: 'WorkOrderCreateModal',

    mixins: [workOrderCreateMixin],

    components: { WorkOrderForm },

    props: {
        onWorkOrderCreated: { type: Function, required: true },
    },

    mounted() {
        this.$analytics.trackModalView(this.$options.name);
    },

    methods: {
        async handleCreate() {
            this.$analytics.trackButtonClick(this.$options.name, 'save', {
                model_type: 'workOrder',
                model_action: 'create',
            });

            const newWorkOrder = await this.createWorkOrder();
            if (newWorkOrder) {
                this.onWorkOrderCreated(newWorkOrder);
                this.$emit('close');
            }
        },

        handleCancel() {
            this.$analytics.trackButtonClick(this.$options.name, 'cancel', {
                model_type: 'workOrder',
                model_action: 'create_cancel',
            });

            this.$emit('close');
        },
    },
}
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.WorkOrderCreateModal {
    @extend %modal;

    .main {
        max-height: 60vh;
        overflow-y: auto;
        margin: 1rem 0;
    }

    .actions {
        display: flex;
        justify-content: flex-end;
        gap: 0.5rem;
    }

    .errorMessage {
        margin: 1rem 0;
        color: $red-color;
        text-align: center;
    }
}
</style>
